module.exports = __webpack_public_path__ + "static/playstore-69605496a6ed3592f41935453c83f70c.png";